<template>
  <div class="wrapper">
    <div class="section text-center">
      <div class="container">
        <h2 class="title">
          {{ $t("landing.pays.titre") }}
        </h2>
        <div class="team">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-33 md-small-size-100">
              <div class="team-player">
                <md-card class="md-card-plain">
                  <div
                    class="md-layout-item md-size-50 mx-auto"
                    @click="gotoPays('canada')"
                  >
                    <img
                      :src="pays1"
                      alt="Thumbnail Image"
                      class="img-raised rounded img-fluid"
                    />
                  </div>
                  <h4 class="card-title" @click="gotoPays('canada')">
                    <br />
                    <small class="card-description text-muted">CANADA</small>
                  </h4>
                </md-card>
              </div>
            </div>

            <div class="md-layout-item md-medium-size-33 md-small-size-100">
              <div class="team-player">
                <md-card class="md-card-plain">
                  <div
                    class="md-layout-item md-size-50 mx-auto"
                    @click="gotoPays('france')"
                  >
                    <img
                      :src="pays2"
                      alt="Thumbnail Image"
                      class="img-raised rounded img-fluid"
                    />
                  </div>
                  <h4 class="card-title" @click="gotoPays('france')">
                    <br />
                    <small class="card-description text-muted">FRANCE</small>
                  </h4>
                </md-card>
              </div>
            </div>
            <div class="md-layout-item md-medium-size-33 md-small-size-100">
              <div class="team-player">
                <md-card class="md-card-plain">
                  <div
                    class="md-layout-item md-size-50 mx-auto"
                    @click="gotoPays('usa')"
                  >
                    <img
                      :src="pays3"
                      alt="Thumbnail Image"
                      class="img-raised rounded img-fluid"
                    />
                  </div>
                  <h4 class="card-title" @click="gotoPays('usa')">
                    <br />
                    <small class="card-description text-muted">USA</small>
                  </h4>
                </md-card>
              </div>
            </div>
            <div class="md-layout-item md-medium-size-33 md-small-size-100">
              <div class="team-player">
                <md-card class="md-card-plain">
                  <div
                    class="md-layout-item md-size-50 mx-auto"
                    @click="gotoPays('turquie')"
                  >
                    <img
                      :src="pays4"
                      alt="Thumbnail Image"
                      class="img-raised rounded img-fluid"
                    />
                  </div>
                  <h4 class="card-title" @click="gotoPays('turquie')">
                    <br />
                    <small class="card-description text-muted">TURQUIE</small>
                  </h4>
                </md-card>
              </div>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-medium-size-33 md-small-size-100">
              <div class="team-player">
                <md-card class="md-card-plain">
                  <div
                    class="md-layout-item md-size-50 mx-auto"
                    @click="gotoPays('japon')"
                  >
                    <img
                      :src="pays6"
                      alt="Thumbnail Image"
                      class="img-raised rounded img-fluid"
                    />
                  </div>
                  <h4 class="card-title" @click="gotoPays('japon')">
                    <br />
                    <small class="card-description text-muted">JAPON</small>
                  </h4>
                </md-card>
              </div>
            </div>

            <div class="md-layout-item md-medium-size-33 md-small-size-100">
              <div class="team-player">
                <md-card class="md-card-plain">
                  <div
                    class="md-layout-item md-size-50 mx-auto"
                    @click="gotoPays('chine')"
                  >
                    <img
                      :src="pays5"
                      alt="Thumbnail Image"
                      class="img-raised rounded img-fluid"
                    />
                  </div>
                  <h4 class="card-title" @click="gotoPays('chine')">
                    <br />
                    <small class="card-description text-muted">CHINE</small>
                  </h4>
                </md-card>
              </div>
            </div>

            <div class="md-layout-item md-medium-size-33 md-small-size-100">
              <div class="team-player">
                <md-card class="md-card-plain">
                  <div
                    class="md-layout-item md-size-50 mx-auto"
                    @click="gotoPays('chypre')"
                  >
                    <img
                      :src="pays7"
                      alt="Thumbnail Image"
                      class="img-raised rounded img-fluid"
                    />
                  </div>
                  <h4 class="card-title">
                    <br />
                    <small
                      class="card-description text-muted"
                      @click="gotoPays('chypre')"
                    >
                      CHYPRE DU NORD
                    </small>
                  </h4>
                </md-card>
              </div>
            </div>
            <div class="md-layout-item md-medium-size-33 md-small-size-100">
              <div class="team-player">
                <md-card class="md-card-plain">
                  <div
                    class="md-layout-item md-size-50 mx-auto"
                    @click="gotoPays('bresil')"
                  >
                    <img
                      :src="pays8"
                      alt="Thumbnail Image"
                      class="img-raised rounded img-fluid"
                    />
                  </div>
                  <h4 class="card-title" @click="gotoPays('bresil')">
                    <br />
                    <small class="card-description text-muted">BRESIL</small>
                  </h4>
                </md-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page",
  components: {},
  props: {
    pays1: {
      type: String,
      default: require("@/assets/img/canada.jpeg")
    },
    pays2: {
      type: String,
      default: require("@/assets/img/france.jpeg")
    },
    pays3: {
      type: String,
      default: require("@/assets/img/usa.jpeg")
    },
    pays4: {
      type: String,
      default: require("@/assets/img/turkie.jpeg")
    },
    pays5: {
      type: String,
      default: require("@/assets/img/chine.jpeg")
    },
    pays6: {
      type: String,
      default: require("@/assets/img/japon.jpeg")
    },
    pays7: {
      type: String,
      default: require("@/assets/img/chypre.jpeg")
    },
    pays8: {
      type: String,
      default: require("@/assets/img/bresil.png")
    },
    pays9: {
      type: String,
      default: require("@/assets/img/ivoir.jpeg")
    },
    pays10: {
      type: String,
      default: require("@/assets/img/sud.jpeg")
    }
  },
  methods: {
    gotoPays(name) {
      this.$router.push({ path: "/pays", query: { pays: name } });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
.md-card-plain {
  cursor: pointer;
}
</style>
